// Temporary workaround. Resolve ASAP. Do not add more ignores like this.
// eslint-disable-next-line eslint-comments/no-restricted-disable
// eslint-disable-next-line @nx/enforce-module-boundaries
import { withServerSideProxy } from '@marketplace-web/shared/ssr'

const sessionStorageHelpers = {
  getSessionStorageItem: (key: string) => sessionStorage.getItem(key),
  removeSessionStorageItem: (key: string) => sessionStorage.removeItem(key),
  setSessionStorageItem: (key: string, value: string) => sessionStorage.setItem(key, value),
}

const serverSafeSessionStorageHelpers = withServerSideProxy(sessionStorageHelpers, {
  getSessionStorageItem: () => null,
})

export const { getSessionStorageItem, removeSessionStorageItem, setSessionStorageItem } =
  serverSafeSessionStorageHelpers
